<template>
  <div class="prodRoot">
    <div class="proPart1Container">
      <div class="proPart1">
        <span class="font9">智慧数字沙盘</span>
        <span class="font10">结合 3D GIS、异构大数据融合、和大数据可视化技术构建的三维数字沙盘管理平台</span>
        <div class="proPart1Img"></div>
      </div>
    </div>
    <div class="proPart2Container">
      <div class="proPart2LeftSide">
        <span class="font11">产品特点</span>
        <span class="font12">
          围绕数据总览、⼤数据决策⽀撑、数据分析等⽅⾯，具备基于三维⼀张图的企业区域数据管理相关的全业务的功能应⽤。
        </span>
      </div>
      <div class="proPart2RightSide">
        <span class="font13">应用场景</span>
        <span class="font14">企业园区管理、能源运维调度、物流运输可视化、企业展厅与展示汇报等多种展示与管理场景。</span>
      </div>
    </div>
    <div class="proPart3Container">
      <div class="proPart3Img"></div>
      <span class="font15">智慧⽣产</span>
      <span class="font16"> 基于 3D GIS 系统，融合各类企业⽣产数据的三维可视化⼤数据管理平台 </span>
      <span class="font17">
        多数据融合、统计，拥有⽣产态势呈现⽣产相关监测、⽣产数据分析等多功能化的综合管理应⽤。
      </span>
      <span class="font18"> 适⽤于多种⾏业⽣产企业的⽣产场所。 </span>
    </div>
    <div class="proPart4Container">
      <span class="font19"> 智慧环保 </span>
      <span class="font20"> 基于 3D GIS 系统，融合各类数据的三维环保可视化管理平台 </span>
      <div class="proPart4Img"></div>

      <div class="proPart4RightTitle">产品特点</div>
      <div class="proPart4RightContent">整合各系统信息数据资源，结合三维地形进⾏多层次、多级数据的展示与监测。</div>

      <div class="proPart4RightTitle2">适用场景</div>
      <div class="proPart4RightContent2">环境监测、环境分析研判、展示汇报等场景。</div>
    </div>
    <!-- <div class="proPart5Container">
				<span class="font21">
					智慧公安
				</span>
				<span class="font22">
					整合公安系统的信息数据资源，基于三维一张图的时空大数据平台呈现海量城市信息要素，实现管辖区域的全面智能监控
				</span>
				<div class="proPart5Img"></div>
			</div> -->
    <div class="proPart6Container">
      <span class="font19"> 智慧规划平台 </span>
      <span class="font20"> 基于 3D GIS、BIM 及时空⼤数据构建的企业级三维空间可视化管理平台。 </span>
      <div class="proPart6RightTitle">产品特点</div>
      <div class="proPart6RightContent">
        整合地上地下、室内室外、历史现状与未来等多源三维信息模型，实现空间数据的统⼀管理、分析与可视化应⽤。平台⽀持从规划设计、项⽬建设到运营管理的全⽣命周期展示，帮助企业实现空间数据资产的数字化、智能化和可视化管理。
      </div>
      <div class="proPart6RightTitle2">适用场景</div>
      <div class="proPart6RightContent">适⽤于园区规划、地产开发项⽬管理、⼯程建设可视化及数字孪⽣应⽤等场景。</div>
      <div class="proPart6Img"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  mounted() {
    document.title = '时空视界|行业产品'
    if (window.createdCallBack) {
      window.createdCallBack(true)
    }
    if (window.updateNavCallBack) {
      window.updateNavCallBack(1)
    }
  },
}
</script>

<style scoped="scoped">
.proPart6RightTitle2 {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  background-image: url(../../assets/icon/icon_scene.png);
  background-size: 33.48px 36px;
  background-repeat: no-repeat;
  width: 194px;
  padding-left: 50px;
  height: 36px;
  margin-left: 14%;
  margin-top: 55px;
}
.proPart6Img {
  width: 697px;
  height: 648.51px;
  background-image: url(../../assets/prod/pic_scene.png);
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: -457px;
  position: relative;
  float: right;
  right: -80px;
}
.proPart6RightContent {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  width: 504px;
  margin-left: 14%;
  margin-top: 20px;
  text-align: left;
}
.proPart6RightTitle {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  background-image: url(../../assets/icon/icon_characteristic.png);
  background-size: 33.48px 36px;
  background-repeat: no-repeat;
  width: 194px;
  padding-left: 50px;
  height: 36px;
  margin-left: 14%;
  margin-top: 212px;
}

.proPart6Container {
  height: 987px;
  overflow: hidden;
}
.proPart5Img {
  background-image: url(../../assets/prod/pic_zhga.jpg);
  width: 1777.78px;
  height: 500px;
  margin-left: 71px;
  margin-top: 100px;
  background-repeat: no-repeat;
  background-size: contain;
}
.font22 {
  font-size: 20px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #d3d3d3;
  line-height: 28px;
  text-align: center;
  display: block;
  padding-top: 20px;
}
.font21 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #ffffff;
  line-height: 50px;
  letter-spacing: 2px;
  display: block;
  text-align: center;
  padding-top: 80px;
}
.proPart5Container {
  height: 868.5px;
  background-image: url(../../assets/prod/bg_zhga.jpg);
  background-size: auto 868.5px;
  /* background-repeat: no-repeat; */
  overflow: hidden;
}
.proPart4RightContent2 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  width: 26.25%;
  margin-left: 60%;
  margin-top: 20px;
  text-align: left;
}
.proPart4RightTitle2 {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  background-image: url(../../assets/icon/icon_scene.png);
  background-size: 33.48px 36px;
  background-repeat: no-repeat;
  width: 194px;
  padding-left: 50px;
  height: 36px;
  margin-left: 60%;
  margin-top: 55px;
}
.proPart4RightContent {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 36px;
  width: 26.25%;
  margin-left: 60%;
  margin-top: 20px;
  text-align: left;
}
.proPart4RightTitle {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  background-image: url(../../assets/icon/icon_characteristic.png);
  background-size: 33.48px 36px;
  background-repeat: no-repeat;
  width: 194px;
  padding-left: 50px;
  height: 36px;
  margin-left: 60%;
  margin-top: 223px;
}
.proPart4Img {
  background-image: url(../../assets/prod/pic_zhhb.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 50%;
  height: 100%;
  margin-left: 86px;
  position: relative;
  background-position: 0px 25%;
  display: inline-block;
  float: left;
}
.font20 {
  font-size: 20px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  text-align: center;
  display: block;
  padding-top: 20px;
  float: left;
  width: 100%;
}
.font19 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 50px;
  letter-spacing: 2px;
  display: block;
  text-align: center;
  padding-top: 80px;
}
.proPart4Container {
  height: 939px;
  overflow: hidden;
}
.font18 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
  display: block;
  padding-top: 27px;
  text-align: left;
  position: relative;
  left: 4.5%;
  width: 83%;
}
.font17 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
  display: block;
  padding-top: 35px;
  text-align: left;
  position: relative;
  left: 4.5%;
  width: 83%;
}
.font16 {
  font-size: 20px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  display: block;
  padding-top: 20px;
  left: 4.5%;
  position: relative;
  width: 83%;
}
.font15 {
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 75px;
  letter-spacing: 2px;
  display: block;
  padding-top: 262px;
  left: 4.5%;
  position: relative;
}
.proPart3Img {
  background-image: url(../../assets/prod/pic_sqsc.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 50%;
  height: 100%;
  margin-left: 86px;
  position: relative;
  background-position: 0px 50%;
  display: inline-block;
  float: left;
}
.proPart3Container {
  height: 860px;
  background: #ededed;
  overflow: hidden;
}
.font14 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
  display: block;
  width: 556px;
  margin-left: 13.5%;
  margin-top: 12px;
  text-align: left;
}
.font13 {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  display: block;
  margin-left: 130px;
  margin-top: 186px;
  margin-left: 13.5%;
}
.font12 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
  display: block;
  width: 576px;
  margin-left: 260px;
  margin-top: 12px;
  text-align: left;
}
.font11 {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #000000;
  line-height: 36px;
  display: block;
  margin-left: 260px;
  margin-top: 186px;
}
.proPart2RightSide {
  width: 960px;
  height: 458px;
  overflow: hidden;
  float: left;
}
.proPart2LeftSide {
  width: 960px;
  height: 458px;
  overflow: hidden;
  float: left;
}
.proPart2Container {
  height: 458px;
}
.proPart1Img {
  background-image: url(../../assets/prod/pic_yingji.png);
  background-repeat: no-repeat;
  background-size: 1200px 648.51px;
  background-position: -70px 0px;
  width: 1120px;
  height: 648.51px;
  z-index: 2;
  bottom: -85px;
  margin: 0 auto;
  position: relative;
}
.font10 {
  width: 100%;
  font-size: 20px;
  /* font-family: SourceHanSansK-Regular; */
  color: #d3d3d3;
  line-height: 20px;
  text-align: center;
  display: block;
  padding-top: 20px;
}
.font9 {
  width: 100%;
  font-size: 50px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #ffffff;
  line-height: 50px;
  letter-spacing: 2px;
  text-align: center;
  display: block;
  padding-top: 80px;
}
.proPart1 {
  height: 812px;
  background-image: url(../../assets/prod/bg_yingji.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.proPart1Container {
  height: 812px;
}
.prodRoot {
  width: 1920px;
}
</style>
